import type { PropsWithChildren } from "react";

import { twMerge } from "tailwind-merge";

import { useDragContext } from "../context/DragContext";
import { DropPreview } from "./DropPreview";

export function DragColumn({
  column,
  className,
  children,
}: PropsWithChildren<{
  column: number;
  className?: string;
}>) {
  const { dragSource, dragPreview } = useDragContext();

  return (
    <div data-drag-column={column} className={twMerge("relative flex flex-col", className)}>
      {children}
      {dragSource && dragPreview && dragPreview.column === column && (
        <DropPreview source={dragSource} preview={dragPreview} />
      )}
    </div>
  );
}
